import React from "react";
import { Link } from "react-router-dom";

import shoppingcart from "./shoppingcart.png";
import addtocart from "./addtocart.png";
import requisition from "./requisition.png";
// import invoice from "./invoice.png";
import consumptionReport from "./consumptionreporticon.png";

const Dashboard = () => {
  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">

                    <div className="col py-2">
                      <Link to="/adminStock" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Stock
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Stock value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={shoppingcart}
                                  alt="shoppingcart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/adminExpenditure"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Expenditure
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Expenditure value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/requisitionList"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Requisition
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={requisition}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/RequisitionListPO"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Purchase Order
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                //   src={invoice}
                                src="https://cdn-icons-png.flaticon.com/512/11449/11449774.png"
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/adminExpenditure2"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Consumption Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={consumptionReport}
                                // src="https://img.freepik.com/premium-vector/report-icon-vector-image-can-be-used-productivity_120816-218012.jpg"
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
